import _core from "./core";
import * as _fizzyUiUtils2 from "fizzy-ui-utils";

var _fizzyUiUtils = "default" in _fizzyUiUtils2 ? _fizzyUiUtils2.default : _fizzyUiUtils2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// page dots
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core, _fizzyUiUtils);
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity, utils) {
  // -------------------------- PageDots -------------------------- //
  function PageDots() {
    // create holder element
    (this || _global).holder = document.createElement("div");
    (this || _global).holder.className = "flickity-page-dots"; // create dots, array of elements

    (this || _global).dots = [];
  }

  PageDots.prototype.setDots = function (slidesLength) {
    // get difference between number of slides and number of dots
    let delta = slidesLength - (this || _global).dots.length;

    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };

  PageDots.prototype.addDots = function (count) {
    let newDots = new Array(count).fill().map((item, i) => {
      let dot = document.createElement("button");
      dot.setAttribute("type", "button");
      let num = i + 1 + (this || _global).dots.length;
      dot.className = "flickity-page-dot";
      dot.textContent = `View slide ${num}`;
      return dot;
    });

    (this || _global).holder.append(...newDots);

    (this || _global).dots = (this || _global).dots.concat(newDots);
  };

  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    let removeDots = (this || _global).dots.splice((this || _global).dots.length - count, count); // remove from DOM


    removeDots.forEach(dot => dot.remove());
  };

  PageDots.prototype.updateSelected = function (index) {
    // remove selected class on previous
    if ((this || _global).selectedDot) {
      (this || _global).selectedDot.classList.remove("is-selected");

      (this || _global).selectedDot.removeAttribute("aria-current");
    } // don't proceed if no dots


    if (!(this || _global).dots.length) return;
    (this || _global).selectedDot = (this || _global).dots[index];

    (this || _global).selectedDot.classList.add("is-selected");

    (this || _global).selectedDot.setAttribute("aria-current", "step");
  };

  Flickity.PageDots = PageDots; // -------------------------- Flickity -------------------------- //

  Object.assign(Flickity.defaults, {
    pageDots: true
  });

  Flickity.create.pageDots = function () {
    if (!(this || _global).options.pageDots) return;
    (this || _global).pageDots = new PageDots();
    (this || _global).handlePageDotsClick = (this || _global).onPageDotsClick.bind(this || _global); // events

    this.on("activate", (this || _global).activatePageDots);
    this.on("select", (this || _global).updateSelectedPageDots);
    this.on("cellChange", (this || _global).updatePageDots);
    this.on("resize", (this || _global).updatePageDots);
    this.on("deactivate", (this || _global).deactivatePageDots);
  };

  let proto = Flickity.prototype;

  proto.activatePageDots = function () {
    (this || _global).pageDots.setDots((this || _global).slides.length);

    (this || _global).focusableElems.push(...(this || _global).pageDots.dots);

    (this || _global).pageDots.holder.addEventListener("click", (this || _global).handlePageDotsClick);

    (this || _global).element.append((this || _global).pageDots.holder);
  };

  proto.onPageDotsClick = function (event) {
    let index = (this || _global).pageDots.dots.indexOf(event.target);

    if (index === -1) return; // only dot clicks

    this.uiChange();
    this.select(index);
  };

  proto.updateSelectedPageDots = function () {
    (this || _global).pageDots.updateSelected((this || _global).selectedIndex);
  };

  proto.updatePageDots = function () {
    (this || _global).pageDots.dots.forEach(dot => {
      utils.removeFrom((this || _global).focusableElems, dot);
    });

    (this || _global).pageDots.setDots((this || _global).slides.length);

    (this || _global).focusableElems.push(...(this || _global).pageDots.dots);
  };

  proto.deactivatePageDots = function () {
    (this || _global).pageDots.holder.remove();

    (this || _global).pageDots.holder.removeEventListener("click", (this || _global).handlePageDotsClick);
  }; // -----  ----- //


  Flickity.PageDots = PageDots;
  return Flickity;
});

export default exports;